import React from "react";
import { List, CreateButton } from "@refinedev/mui";
import { DataGrid } from "@shared/components/DataGrid";

import { CsvExportButton, FilterDropdown } from "@shared/components";
import { BookListFilters } from "@modules/books/components";

import { useAgreementsPlansList } from "./controller";
import { useBooksListColumns } from "./columns";

export const BookList = React.memo(() => {
  const {
    rows,
    loading,
    selectedRows,
    dataToExport,
    setSelectedRows,
    refetch,
    translate,
    tableProps
  } = useAgreementsPlansList();

  const columns = useBooksListColumns(refetch, translate);

  return (
    <List
      headerButtons={
        <>
          <FilterDropdown
            initialValues={{
              search: "",
              sector: "",
              categories: "",
              month_featured: "",
              month_featured_year: "",
              type: "",
              is_best_seller: "",
              origin: "",
              levels_rank: "",
              agreement_id: "",
            }}
          >
            <BookListFilters />
          </FilterDropdown>

          <CsvExportButton
            data={dataToExport}
            filename="agreements.csv"
            isDisabled={loading || !rows}
          />

          <CreateButton />
        </>
      }
    >
      <DataGrid
        {...tableProps}
        rows={rows}
        loading={loading}
        columns={columns} checkboxSelection
        rowSelectionModel={selectedRows}
        onRowSelectionModelChange={(selectionModel) =>
          setSelectedRows(selectionModel as number[])
        }
      />
    </List>
  );
});
